module.exports = {
    all: "/ds/*",
    tripInfoPath: "/ds/:id",
    tripInfo: "/ds/",
    map: "/ds/map",
    driver_locationPath: "/ds/driver-location/:id",
    driver_location: "/ds/driver-location/",


}